module.exports = __webpack_public_path__ + "static/ABCC-63d7ff3d724837a4e7e113ada3894e63.png";